export default "__VITE_ASSET__CxQstqSh__"